
















































import { mapGetters, mapActions } from "vuex";
import { General } from "@/utils/constants";
import CircleLoading from "@/components/CircleLoading";
import { IDocumentDOE } from "@/store/types/doe-types";

export default {
  name: "ListDocumentsDoe",
  components: {
    CircleLoading
  },
  data() {
    return {
      General
    };
  },

  computed: {
    ...mapGetters({
      getDoeSnackList: "getDoeSnackList"
    }),

    showCancelButton() {
      return this.getDoeSnackList.some(
        ({ status }: IDocumentDOE) => status === "pending"
      );
    }
  },

  watch: {
    getDoeSnackList: {
      handler(listDoeActions) {
        const countActions = listDoeActions.filter(({ status }: IDocumentDOE) =>
          ["pending", "processing"].includes(status)
        ).length;
        let newTitle = this.General.TEXTS.ACTION_FINISHED;
        if (countActions) {
          const mensage =
            countActions === 1
              ? this.General.TEXTS.ACTION_QUANTITY_SINGULAR
              : this.General.TEXTS.ACTION_QUANTITY;
          newTitle = mensage.replace("(QUANTITY)", countActions);
        }
        this.$emit("updateTitle", newTitle);
      },
      deep: true
    }
  },

  methods: {
    ...mapActions({
      setCancelDoeAction: "setCancelDoeAction"
    }),

    actionCancel(listIndex = -1) {
      this.setCancelDoeAction(listIndex);
    }
  }
};
